<template>
  <a class="message-thread" :href="threadUrl">
    <div class="time">
      {{ timeAgo(lastMessageSentAt) }}
    </div>
    <div class="author-name text-primary">
      {{ author.name }}
    </div>
    <div class="thread-title">
      {{ title }}
    </div>
    <div class="comments-count">
      {{ i18n.t('member.forums.comments_count', {count: replies.length}) }}
    </div>
  </a>
</template>

<script>
export default {
  props: {
    author: {
      type: Object,
      required: true
    },
    lastMessageSentAt: {
      type: String, // TODO make Date
      required: true
    },
    title: {
      type: String,
      required: true
    },
    replies: {
      type: Array,
      required: true
    },
    threadUrl: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  @use "~friendship_styles/colors" as colors;

  a.message-thread {
    width: 100%;
    display: flex;
    padding: 15px 0;

    // Remove link default styling
    text-decoration: none;
    color: unset;
  }

  .time, .author-name, .comments-count {
    flex-basis: 20%;
  }

  .thread-title {
    flex: 1
  }

  .comments-count {
    color: colors.$dark-gray-text-color;
  }
</style>
